<template>
  <div class="rt-approval"><slot /></div>
</template>
<script>
export default {
  name: 'RtApproval'
};
</script>
<style lang="less">
.rt-approval {
  position: relative;
  padding-top: 20px;
  border-top: 1px solid #e8ecfc;
  &::before {
    content: '';
    position: absolute;
    top: 30px;
    left: 10px;
    bottom: 38px;
    border-left: 1px solid #e8e8e8;
    z-index: 0;
  }
  .rt-approval-item {
    display: flex;
    position: relative;
    &:not(:first-child) {
      margin-top: 34px;
    }
    .rt-icon {
      margin-top: -2px;
    }
    .rt-approval-item-middle {
      margin-left: 17px;

      .title {
        color: #4f5e7b;
        font-size: 16px;
        font-weight: 500;
      }

      .status {
        font-size: 14px;
        color: #6388c2;
        margin-top: 10px;
      }
    }
    .time {
      position: absolute;
      right: 0;
      top: 1px;
      font-size: 14px;
      color: #a9c2e8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtApproval.vue?673d1f24